import { ReactNode } from 'react';

interface MobileLayoutProps {
  children: ReactNode;
}

export const MobileLayout = ({ children }: MobileLayoutProps) => {
  return (
    <div className="h-dvh w-screen flex flex-col overflow-hidden">
      {/* Map area - takes full viewport */}
      <div className="flex-grow relative">{children}</div>

      {/* Bottom action bar - will be populated in later phases */}
      <div className="flex-shrink-0 bg-background border-t">
        {/* Action buttons (filters, layers, etc.) will go here */}
      </div>
    </div>
  );
};
